import { render, staticRenderFns } from "./AliOss.vue?vue&type=template&id=955a72ea&scoped=true&"
import script from "./AliOss.vue?vue&type=script&lang=js&"
export * from "./AliOss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955a72ea",
  null
  
)

export default component.exports